import React, {useEffect} from 'react'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {ProjectsFlatTreeDropdownContent} from '@components/common/projects-tree/projects-tree'
import {TaskItem} from '@components/my-tasks/task-item'
import {BooleanHookState, useBoolean} from '@containers/hooks'
import {Props} from './task-menu-new'
import {TaskMenuNewDropdown} from './task-menu-new-dropdown'

export interface InnerProps {
  canComplete?: boolean
  toggleComplete(): void
  toggleArchive(): void
  deleteTask(): void
  moveTask?: (column: Hub[]) => void
  selectMultipleTasksToggleOn(): void
  canChangeBoardSettings?: boolean
  hub: Hub
  onToggle?: (value: boolean) => void
  reference: React.RefObject<Element> | Element | null
  onCloseRequest: () => void
}

export const TaskMenuOnlyBase = (props: Props & InnerProps) => {
  const {task, moveTask, reference, onCloseRequest} = props

  /**
   * I have to use this strange way to close the menu, because TaskMenuNewDropdown uses `moveOpen` state provided by useBoolean
   * Anyway only when both states are false, the menu should be closed
   */
  const menuOpen = useBoolean(true)
  const moveOpen = useBoolean(false)

  useEffect(() => {
    if (!menuOpen.value && !moveOpen.value) {
      onCloseRequest()
    }
  }, [menuOpen.value, moveOpen.value])

  return (
    <>
      {menuOpen.value && (
        <TaskMenuNewDropdown
          {...props}
          reference={reference}
          closeMenu={() => {
            menuOpen.turnOff()
          }}
          moveOpen={moveOpen}
        />
      )}
      <MovementDropdown
        reference={reference}
        task={task}
        moveTask={moveTask}
        moveOpen={moveOpen}
      />
    </>
  )
}

interface MovementDropdownProps {
  reference: React.RefObject<Element> | Element | null
  task: TaskItem
  moveTask?: (column: Hub[]) => void
  moveOpen: BooleanHookState
  callback?: (location: DataObjectId) => void
}

const MovementDropdown = (props: MovementDropdownProps) => {
  const {reference, task, moveTask, moveOpen, callback} = props
  if (!moveOpen.value) {
    return null
  }

  const chooseLocation = (locationId: DataObjectId) => {
    if (callback) {
      callback(locationId)
    }

    if (moveTask) {
      const box = Sync.get(task)
      const hub = box.getHub(locationId)

      hub && moveTask([hub])
    }

    moveOpen.turnOff()
  }

  return (
    <Dropdown
      reference={reference}
      hideArrow
      content={
        <ProjectsFlatTreeDropdownContent
          value={task.location}
          onChange={chooseLocation}
        />
      }
      visible={moveOpen.value}
      onVisibleChange={moveOpen.turnOff}
    />
  )
}
